<script>
    import { onDestroy, onMount } from "svelte";

    import {
        user,
        createUser,
        createAccount,
        loggedInDoctorDetail,
        isMobile,
    } from "../../stores";

    import { goToURL } from "../../Utils/utilFunctions.svelte";

    import CreateAccountForm from "./SignUpComponents/createAccountForm.svelte"; // 1
    import EmailValidationForm from "./SignUpComponents/emailValidationForm.svelte"; // 2
    import PersonalDetailsForm from "./SignUpComponents/personalDetailsForm.svelte"; // 3
    import ProviderDetailsForm from "./SignUpComponents/providerDetailsForm.svelte"; // 4
    import PrivacyPolicy from "./SignUpComponents/PrivacyPolicy.svelte"; // 5
    import TermsNConditions from "./SignUpComponents/Terms_n_Conditions.svelte"; // 6
    import SignaturePage from "./SignUpComponents/SignaturePage.svelte"; // 7
    import BillingRules from "./SignUpComponents/BillingRules.svelte"; // 8
    import HearAboutUs from "./SignUpComponents/HearAboutUs.svelte"; // 9

    import { apiMethods } from "../../Services/index.svelte";

    let signUpPhase = 1;
    // let signUpPhase = 9;

    let personalDetails = {};

    onMount(async () => {
        if ($createAccount.id) {
            personalDetails = {
                ...$loggedInDoctorDetail,
                email: $createAccount.email,
                verifiedPhone: $createAccount.verifiedPhone,
                verifiedEmail: $createAccount.verifiedEmail,
                createdUserId: $createAccount.id,
                claimDelayHours: Number(24),
            };
            updateSignUpPhase();
        } else
            personalDetails = {
                createdUserId: $createUser.id,
                title: 5,
                claimDelayHours: Number(24),
            };
    });

    onDestroy(() => {
        $createUser = {};
    });

    const updateSignUpPhase = () => {
        if (!personalDetails.verifiedEmail) updatePhase(2);
        else if (!personalDetails.phone || !personalDetails.verifiedPhone)
            updatePhase(3);
        else if (
            !personalDetails.userAccounts ||
            personalDetails.userAccounts.length == 1
        ) {
            if (!personalDetails.providers) updatePhase(4);
            else if (!personalDetails.signatureApproved) updatePhase(7);
        } else updatePhase(8);
    };

    const updatePhase = async (phase) => {
        signUpPhase = phase;

        if (signUpPhase == 10) await handleLogin();
    };

    const handleLogin = async () => {
        await apiMethods.postMethod.logIn($createUser).then((res) => {
            if (res.id && res.id == $createUser.id) {
                $createUser = {};
                $createAccount = {};

                $user.token = res.token;
                $user.refreshToken = res.refreshToken;
                $user.id = res.id;
                $user.name = res.name;
                $user.expiration = res.expiration;
                $user.role = res.role;
            }
        });

        goToURL("/");
    };
</script>

<div
    class="flex-1 flex flex-col items-center w-full h-full p-6 showBG gap-y-4 overflow-y-auto"
>
    <div class="flex items-center px-4 py-2">
        <img src="/favicon.png" alt="" class="w-[48px] h-[48px]" />
        <p class="text-primary text-2xl font-bold title-font pl-4">Anaemate</p>
    </div>

    <div class="flex flex-1 items-center justify-evenly w-full">
        <div
            class="artboard artboard-demo h-auto gap-4 p-6 shadow-lg {$isMobile
                ? 'w-full'
                : 'w-[500px]'}"
        >
            {#if signUpPhase == 1}
                <CreateAccountForm {updatePhase} bind:personalDetails />
            {:else if signUpPhase == 2}
                <EmailValidationForm {updatePhase} bind:personalDetails />
            {:else if signUpPhase == 3}
                <PersonalDetailsForm {updatePhase} bind:personalDetails />
            {:else if signUpPhase == 4}
                <ProviderDetailsForm {updatePhase} bind:personalDetails />
            {:else if signUpPhase == 5}
                <PrivacyPolicy {updatePhase} />
            {:else if signUpPhase == 6}
                <TermsNConditions {updatePhase} />
            {:else if signUpPhase == 7}
                <SignaturePage {updatePhase} bind:personalDetails />
            {:else if signUpPhase == 8}
                <BillingRules {updatePhase} bind:personalDetails />
            {:else if signUpPhase == 9}
                <HearAboutUs {updatePhase} bind:personalDetails />
            {/if}
        </div>
    </div>
</div>

<style>
    .artboard {
        background-color: #f7f7f7;
        border: 1px solid rgba(65, 91, 63, 0.25);
        box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.1);
        border-radius: 15px;
    }

    .showBG {
        height: 100vh;
        background-image: url("/imgs/bg_signIn.png");
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-position: bottom;
        background-size: contain;
    }
</style>
